import { supabase } from "@/integrations/supabase/client";

type Action = "list_upcoming" | "audit_period" | "finalize_payment" | "record_adjustment" | "history" | "list_payees";

export async function callPartnerPayments<T = any>(action: Action, body: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await supabase.functions.invoke("partner-payments", { body: { action, ...body } });
  if (error) throw error;
  return data as T;
}

export interface PartnerPerClass { class_id: string; registration_count: number; gross_cents: number; refund_cents: number; net_cents: number; }
export interface PartnerCalculation {
  period_start: string; period_end: string;
  gross_qualifying_revenue_cents: number; refund_adjustments_cents: number; net_qualifying_revenue_cents: number;
  percentage: number; amount_due_cents: number;
  per_class: PartnerPerClass[];
  included_payment_ids: string[];
  included_payments: Array<{ id: string; class_id: string; adult_name: string | null; email: string | null; amount_paid_cents: number; refunded_cents: number; created_at: string; stripe_session_id: string | null }>;
  excluded_payments: Array<{ id: string; reason: string; class_id: string; amount_paid: number }>;
  reporting_cutoff: string;
}
export interface PartnerUpcomingItem {
  payee: { id: string; name: string; active: boolean; default_payment_method: string | null; notes: string | null };
  agreement_id: string;
  period: { label: string; start: string; end: string; due_date: string; days_until_due: number };
  calculation: PartnerCalculation;
  calculated_through: string;
  already_paid: boolean;
  existing_ledger: any;
}

export const listUpcomingPartnerPayments = () => callPartnerPayments<{ items: PartnerUpcomingItem[] }>("list_upcoming");
export const auditPartnerPeriod = (agreement_id: string, period_start?: string, period_end?: string) =>
  callPartnerPayments<{ agreement: any; calculation: PartnerCalculation }>("audit_period", { agreement_id, period_start, period_end });
export const finalizePartnerPayment = (payload: {
  agreement_id: string; period_start: string; period_end: string;
  payment_date: string; payment_method?: string; reference?: string; notes?: string; receipt_url?: string;
}) => callPartnerPayments("finalize_payment", payload);
export const partnerPaymentHistory = (payee_id?: string) => callPartnerPayments<{ rows: any[] }>("history", { payee_id });
export const listPartnerPayees = () => callPartnerPayments<{ payees: any[]; agreements: any[] }>("list_payees");

export const money = (cents: number) => `$${(cents / 100).toFixed(2)}`;
